import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Act } from '../../models/act';
import { ActService } from '../../services/act.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { FileUploaderService } from '../../services/fileuploader.service';
import { DocumentServerService } from '../../services/documentdownload.Service';
// import{DocumentServerService} from '../../services/documentdownload.Service';

@Component({
  selector: 'app-act',
  templateUrl: './act.component.html',
  styleUrls: ['./act.component.css']
})
export class ActComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerAct: PageHeader;
  entity: Act = new Act();
  editingEntity: Act = new Act();
  selectedAct: Act = new Act();
  acts: any;
  actColumns: any[] = [];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  path: string = "";
  fileName: string = "";
  url = '';
  isButtonVisible: boolean = false;
  isDownloadButtonVisible: boolean = false;
  opened: boolean = false;
  details: any;
  documentdownload: any;
  constructor(
    private _actService: ActService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private fileUploader: FileUploaderService,
    private documentdownloadservice: DocumentServerService,
  ) {
    this.headerAct = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.acts = [];
    this.getAllActs();
  }
  ngAfterViewInit(): void {
    this.actColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 50 },
      { field: "ActName", title: 'Act', filter: true, sortable: true, width: 120 },
      { field: "Description", title: 'Description', filter: true, sortable: true, width: 120 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._actService.getAllAct('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Act>) => {
      this.acts = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._actService.getAllAct(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((acts: Array<Act>) => {
        this.acts = {
          data: acts,
          total: acts[0] ? acts[0].TotalCount : 0
        }
      });
    }
  }
  getAllActs() {
    this._actService.getAllAct('', Number(this.defaultPageSize), 1, 0, 0).subscribe((acts: Array<Act>) => {
      this.acts = {
        data: acts,
        total: acts[0] ? acts[0].TotalCount : 0
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._actService.deleteAct(this.selectedAct.Act_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearAct();
            this.getAllActs();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView = true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerAct = new PageHeader();
    headerAct.PageCaption = "Act";
    headerAct.IconClass = "bi bi-building";
    return headerAct;
  }

  deleteAct(event: any) {
    if (event.seletedRows[0]) {
      this.selectedAct.Act_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Act",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addAct(event: any) {
    this.listView = false;
    this.clearAct();
    this.formCaption = "Add Act";
    this.path = '';
    this.url = '';
  }

  downloadFunction(file: any): void {
    // let documentId = entity.Ref_Id;
    if(this.entity.Ref_Id!=null && this.entity.FileName!=null){
      this.documentdownloadservice.downloadFile(file) 
    }
    else{
      this.notification.showWarning('No documents found');
    }
    
  }

  editAct(event: any): void {
    if (event.seletedRows[0]) {
      this._actService.viewAct(event.seletedRows[0]).subscribe((acts: Array<Act>) => {
        let editAct = acts[0] ? acts[0] : new Act();
        if (editAct) {
          this.editingEntity = editAct;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Act";
          this.isDownloadButtonVisible = true;
          if (this.entity.FileName != null) {
            this.path = this.configService.getConfigValue('FileWriteLocation');
            this.url = this.path + this.entity.FileName;
            this.isButtonVisible = true;
          }
          else {
            this.path = '';
            this.url = '';
            this.isButtonVisible = false;
            this.entity.Document = null;
          }
          this.entity.EntityMetaData = [
            { FieldName: 'ActName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Act Name is required' },
          ];
        }
      });
    }
  }

// this.entity.Document = this.entity.FileName
            // this.documentdownloadservice.getDocumentContent(this.entity.Ref_Id).then((acts: Array<Act>) => {
            //   if (acts[0]) {
            //     var link: any = document.createElement("link");
            //     // link.href=URL.createObjectURL(this.entity.Ref_Id)
            //     link.href = URL.createObjectURL(this.entity.Document);
            //     link.download = this.entity.Document.FileName;
            //     this.documentdownload = this.entity.Document.FileName;

            //   }

            // link.setAttribute("href", result);
            // link.setAttribute("download", this.entity.FileName);
            // link.style.display = "none";
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // })

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._actService.checkDuplication(this.entity.ActName, this.entity.Act_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Act already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Document != null && this.entity.Document != undefined) {
            this.fileUploader.upload(this.entity.Document, '').subscribe((result: any) => {
              if (result.succeeded) {
                this.entity.Ref_Id = result.documentId;
              }
              this._actService.saveAct(this.entity).subscribe(() => {
                if (this.entity.Act_Id == "00000000-0000-0000-0000-000000000000") {
                  this.notification.showSuccess('Saved Successfully');
                }
                else {
                  this.notification.showSuccess('Updated Successfully');
                }
                this.listView = true;
                this.clearAct();
                this.getAllActs();
              })
            });
          }
          else {
            // this.entity.Ref_Id = null;
            this._actService.saveAct(this.entity).subscribe(() => {
              if (this.entity.Act_Id == "00000000-0000-0000-0000-000000000000") {
                this.notification.showSuccess('Saved Successfully');
              }
              else {
                this.notification.showSuccess('Updated Successfully');
              }
              this.listView = true;
              this.clearAct();
              this.getAllActs();
            })
          }
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.clearAct();
  }
  refreshAct(event: any): void {
    this.acts = [];
    this.getAllActs();
  }
  clearAct(): void {
    this.entity = new Act();
    this.saveDisabled = false;
    this.url = '';
    this.isButtonVisible = false;
    this.entity.Document = null;
    this.documentdownload = "";
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  fileChanged(event: any) {
    this.isDownloadButtonVisible=false;
    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && event.target.files[0].type != 'application/pdf') {
        this.notification.showWarning('Choose correct File Format');
      }
      if (event.target.files[0].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || event.target.files[0].type == 'application/pdf') {

        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.url = String(event.target?.result);
          this.isButtonVisible = true;
        }
        //view and download document before upload
        this.entity.Document = event.target.files[0];
        const link: any = document.getElementById("link")
        link.download = this.entity.Document.name;
        link.href = URL.createObjectURL(this.entity.Document)
        this.documentdownload = this.entity.Document.name;
      }
    }
  }

  removeImage(event: any) {
    this.url = '';
    this.isButtonVisible = false;
    this.entity.Document = null;
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Act_Id = dataItem.Act_Id;
    this.details = [];
    this._actService.viewAct(this.entity.Act_Id).subscribe((acts: Array<Act>) => {
      this.opened = true;
      this.details = acts[0];
    })
  }
}
